import React from "react";
import styled from "@emotion/styled";

import Typography from "@material-ui/core/Typography";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Tooltip from "@material-ui/core/Tooltip";

import { useField, useFormikContext } from "formik";

export const RadioCard = styled(Card)(({ selected, disabled }) => ({
  width: "31.3%",
  margin: "1%",
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? "none" : "all",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  ...(selected && { boxShadow: "0 0 0 2pt #a8bb43" }),
}));

export const RadioCardMedia = styled(CardMedia)({
  height: 70,
});

export const RadioCardContent = styled(CardContent)({
  padding: 10,
});

export const TooltipContent = styled.div({
  color: "white",
  fontSize: 14,
  lineHeight: 1.2,
});

const RadioOption = ({ option, name }) => {
  const { description, images } = option;
  const [field, meta, helpers] = useField({ name });

  const { setFieldValue } = useFormikContext();

  return (
    <RadioCard
      onClick={() => {
        //NOTE: hardcoded side-effect for last quanitty step with number and radios
        if (name === "quantity") {
          setFieldValue("prefered-amount", "");
        }
        helpers?.setValue(option.code);
        helpers?.setTouched(true);
      }}
      selected={field.value === option.code}
      disabled={!option?.available}
    >
      <Tooltip
        title={<TooltipContent>{description}</TooltipContent>}
        disableHoverListener={!description}
        arrow
      >
        <CardActionArea>
          {images[0]?.url && (
            <RadioCardMedia
              image={images[0]?.url}
              title="Contemplative Reptile"
            />
          )}
          <RadioCardContent>
            <Typography variant="subtitle2" component="h2">
              {option.name}
            </Typography>
          </RadioCardContent>
        </CardActionArea>
      </Tooltip>
    </RadioCard>
  );
};

export default RadioOption;
